import { render, staticRenderFns } from "./bo-numeric.vue?vue&type=template&id=9559fa2e"
import script from "./bo-numeric.vue?vue&type=script&lang=js"
export * from "./bo-numeric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports